// extracted by css-extract-rspack-plugin
export default {"bui-Grid":"lOUUwZ1G_vYgdngG"};